export default "__VITE_ASSET__cUYiwXUY__"